<!--协同备课、听评课总数统计饼图-->
<template>
    <div class="my-charts">
        <div :id="id"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";

export default {
    name: "teaXbEchart",
    props: {
        id:{
            type: String,
            default:"tea_xb_pie_echarts"
        },
        manCount:{
            type: Number,
            default: 0
        },
        womanCount:{
            type: Number,
            default: 0
        },
    },
    watch:{
        id(newValue,oldValue){
            this.id = newValue;
        },
        // statsType(newValue,oldValue){
        //     this.statsType = newValue;
        //     this.init()
        // },
        // title(newValue,oldValue){
        //     this.title = newValue;
        //     this.init()
        // },
        // totalCount(newValue,oldValue){
        //     this.totalCount = newValue;
        //     this.init()
        // },
        // teamCount(newValue,oldValue){
        //     this.teamCount = newValue;
        //     this.init()
        // },
        // userCount(newValue,oldValue){
        //     this.userCount = newValue;
        //     this.init()
        // },
        // echartsTitle(newValue,oldValue){
        //     this.echartsTitle = newValue;
        //     this.init()
        // },
        // yearCode(newValue,oldValue){
        //     this.yearCode = newValue;
        //     this.init()
        // },
        // onlineCount(newValue,oldValue){
        //     this.onlineCount = newValue;
        //     this.init()
        // },
        // offlineCount(newValue,oldValue){
        //     this.offlineCount = newValue;
        //     this.init()
        // },
    },
    data() {
        return {
            pieChart: null, // 饼图
            chartOption:{
                title: {
                    text: '',
                    left: 'center',
                    top: 10,
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    show: false,
                    bottom:0,
                },
                graphic: [
                    {
                        type: "text",
                        left: "center",
                        top: "center",
                        style: {
                            text: '',
                            textAlign: "center",
                            fill: "#333333",
                            lineHeight:30,
                            fontSize: 14
                        },
                    },
                ],
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: ['50%', '75%'],
                        avoidLabelOverlap: false,
                        color: [
                            '#5087ec',
                            '#68bbc4',
                        ],
                        itemStyle: {
                            borderRadius: 0,
                            borderColor: '#fff',
                            borderWidth: 1
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: 10,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        data: []
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            const list = []
            list.push({'value':this.manCount,'name':"男"});
            list.push({'value':this.womanCount,'name':"女"});
            this.pieChart = echarts.init(document.getElementById(this.id));
            this.chartOption.series[0].data = []
            this.chartOption.series[0].data = list;
            this.chartOption.graphic[0].style.text = "性别";
            this.pieChart.setOption(this.chartOption);
        }
    }
};
</script>

<style scoped lang="scss">
.my-charts {
    flex-direction: column;
    div {
        width: 100%!important;
        height: 100px;
    }
}
</style>